module.exports = __webpack_public_path__ + "static/img/donation_success_image.8310f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/donation_success_image.png
// module id = aC62
// module chunks = 1